import { ulid } from 'ulid';

export function getElementUlId() {
    return ulid();
}
